import { lazy } from 'react';

export default [
    {
        path: '/rickyliu',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'MangaChatLayout' */ './layout')),
    },
];
